// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/umweltpakt-bayern-2-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const umweltpaktBayern222DE: PageEntry = {
  id: "post.umweltpakt-bayern-2-2-2",
  locale: "de",
  slug: "umweltpakt-bayern-2-2-2",
  seo: {
    title: "„Energieautark in die Zukunft! | Dietz GmbH",
    description: "„Energieautark in die Zukunft!",
  },
  type: "post",
  h1: "„Energieautark in die Zukunft!",
  blocks: [
    { kind: "heading", level: 2, text: "„Energieautark in die Zukunft!" },
    { kind: "paragraph", text: "Mit dem neuen Verwaltungsgebäude setzen wir einen weiteren Meilenstein in Sachen Nachhaltigkeit. Durch ein ausgeklügeltes, energetisches System modernster Wärmeerzeugung in Verbindung mit einer Photovoltaikanlage und einer Stromspeicherung, kann das Gebäude über 85 % seines Energiebedarfs selbständig erzeugen.“" }
  ],
};
